import { useEffect, type RefObject } from "react";

/**
 * Calls `onOutside` when a pointerdown or focus lands outside `ref`, or when
 * Escape is pressed — only while `active` is true. Replaces the legacy global
 * outside-click handlers (`_setupExportMenus`, tag-suggestion close, etc.).
 */
export function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T>,
  active: boolean,
  onOutside: () => void,
): void {
  useEffect(() => {
    if (!active) return;
    function handlePointer(event: MouseEvent): void {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onOutside();
      }
    }
    function handleKey(event: KeyboardEvent): void {
      if (event.key === "Escape") onOutside();
    }
    document.addEventListener("mousedown", handlePointer);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handlePointer);
      document.removeEventListener("keydown", handleKey);
    };
  }, [ref, active, onOutside]);
}
